import { cn } from "@/lib/utils";

type Variant = "neutral" | "success" | "warning" | "danger" | "info" | "primary";

const styles: Record<Variant, string> = {
  neutral: "bg-muted text-muted-foreground",
  success: "bg-[hsl(150_55%_94%)] text-[hsl(150_65%_25%)] border-[hsl(150_50%_80%)]",
  warning: "bg-[hsl(36_92%_94%)] text-[hsl(36_92%_30%)] border-[hsl(36_85%_75%)]",
  danger: "bg-[hsl(0_75%_96%)] text-[hsl(0_75%_35%)] border-[hsl(0_75%_82%)]",
  info: "bg-[hsl(200_95%_94%)] text-[hsl(200_95%_28%)] border-[hsl(200_95%_80%)]",
  primary: "bg-primary-50 text-primary-700 border-primary-200",
};

export function StatusBadge({
  variant = "neutral",
  children,
  className,
}: {
  variant?: Variant;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 h-5 px-2 text-xxs font-medium rounded-sm border border-transparent tracking-wide",
        styles[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
